<template>
  <div>
    <Box theme="box-primary" title="Tìm kiếm">
      <div slot="content">
        <div class="col-md-12 col-sm-12 col-xs-12">
          <b>Chọn file (.xlsx <a
            :href="sampleLink">Tải về
            file
            mẫu</a>)</b>
        </div>
        <div class="form-group col-md-8 col-sm-8 col-xs-8">
          <b-form-file
            v-model="phoneNumberFile"
            :state="Boolean(phoneNumberFile)"
            accept="text/xlsx"
            placeholder="Chọn file xlsx hoặc thả vào đây..."
            drop-placeholder="Thả file vào đây..."
            required
          ></b-form-file>
        </div>
      </div>
      <div slot="footer">
        <div class="d-flex">
          <b-button variant="success" class="w-150px" @click="handleImportPhoneNumber">
            Import
          </b-button>
          <b-button variant="warning" class="w-120px ml-3" @click="confirmImportPhoneNumber"
                    :disabled="record_id === null">
            Xác nhận
          </b-button>
        </div>
      </div>
    </Box>
    <Box theme="box-primary" title="Danh sách import">
      <div slot="content">
        <b-table bordered outlined hover responsive :busy="loading" :fields="type === 'IMPORT_NEW' ? fields : type === 'IMPORT_STATUS'? statusFields : type === 'IMPORT_FEE' ? feeFields : lockInfoFields" :items="items"
                 show-empty>
          <template #table-busy>
            <div class="text-center my-2 mt-5 mb-5">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Đang tải...</strong>
            </div>
          </template>

          <template #empty="scope">
            <h4 class="text-center text-bold mt-5 mb-5" v-if="record_id === null">Không có dữ liệu</h4>
            <h4 class="text-center text-bold mt-5 mb-5 color-blue" v-if="record_id !== null">File excel hợp lệ, chọn xác nhận để thực hiện import</h4>
          </template>
          <template v-slot:cell(error_codes)="data">
            <li v-for="error_code in data.item.error_codes" :key="error_code">
              {{ generateErrorFromErrorCode(error_code) }}
            </li>
          </template>
        </b-table>
      </div>
    </Box>
  </div>
</template>

<script>
import Box from '../../../components/Box'
import Utils from '../../../common/utils'
import {mapGetters} from 'vuex'
import {IMPORT_ERROR_CODE} from '../../../common/constant'
import PhoneNumberApi from '../../../api/phoneNumberApi'

export default {
  name: 'ImportPhoneNumberSection',
  props: {
    type: {
      type: String,
      required: true
    },
  },
  components: {
    Box,
  },
  data () {
    return {
      sampleLink: 'https://drive.google.com/uc?export=download&id=1ynHpUd5D8oncU05Tp7LzNM8XlpoRrAaC',
      company: null,
      phoneNumberFile: null,
      record_id: null,
      items: [],
      fields: [
        {
          key: 'phone_number',
          label: 'Số điện thoại',
        },
        {
          key: 'pickup_date',
          label: 'Ngày lấy',
        },
        {
          key: 'main_phone_number',
          label: 'Số chủ',
        },
        {
          key: 'provider',
          label: 'Nhà cung cấp',
        },
        {
          key: 'legal',
          label: 'Pháp nhân',
        },
        {
          key: 'phone_number_client',
          label: 'KH sử dụng',
        },
        {
          key: 'brand',
          label: 'Brand',
        },
        {
          key: 'phone_number_status',
          label: 'Trạng thái số',
        },
        {
          key: 'init_fee',
          label: 'Phí khởi tạo',
        },
        {
          key: 'init_payment_date',
          label: 'Ngày nhập phí khởi tạo',
        },
        {
          key: 'operate_fee',
          label: 'Phí duy trì',
        },
        {
          key: 'operate_payment_date',
          label: 'Ngày nhập phí duy trì',
        },
        {
          key: 'open_fee',
          label: 'Phí mở',
        },
        {
          key: 'open_payment_date',
          label: 'Ngày nhập phí mở',
        },
        {
          key: 'other_fee',
          label: 'Phí khác',
        },
        {
          key: 'other_payment_date',
          label: 'Ngày nhập phí khác',
        },
        {
          key: 'note',
          label: 'Ghi chú',
        },
        {
          key: 'error_codes',
          label: 'Mã lỗi',
        }
      ],
      statusFields: [
        {
          key: 'phone_number',
          label: 'Số điện thoại',
        },
        {
          key: 'phone_number_status',
          label: 'Trạng thái số',
        },
        {
          key: 'phone_number_client',
          label: 'KH sử dụng',
        },
        {
          key: 'error_codes',
          label: 'Mã lỗi',
        }
      ],
      feeFields: [
        {
          key: 'phone_number',
          label: 'Số điện thoại',
        },
        {
          key: 'payment_date',
          label: 'Ngày nhập phí',
        },
        {
          key: 'on_net_fee',
          label: 'Phí nội mạng',
        },
        {
          key: 'off_net_fee',
          label: 'Phí ngoại mạng',
        },
        {
          key: 'billing_month',
          label: 'Tháng tính phí',
        },
        {
          key: 'error_codes',
          label: 'Mã lỗi',
        }
      ],
      lockInfoFields: [
        {
          key: 'phone_number',
          label: 'Số điện thoại',
        },
        {
          key: 'using_providers',
          label: 'Mạng đang sử dụng',
        },
        {
          key: 'lock_provider',
          label: 'Mạng khóa',
        },
        {
          key: 'lock_date',
          label: 'Ngày khóa',
        },
        {
          key: 'open_provider',
          label: 'Mạng mở',
        },
        {
          key: 'open_date',
          label: 'Ngày mở',
        },
        {
          key: 'lock_status',
          label: 'Trạng thái khóa số',
        },
        {
          key: 'send_provider_date',
          label: 'Ngày gửi NCC',
        },
        {
          key: 'cancel_date',
          label: 'Ngày hủy',
        },
        {
          key: 'error_codes',
          label: 'Mã lỗi',
        }
      ],
      loading: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  mounted () {
    this.company = Utils.getCompanyByUserInfo(this.userInfo)
    if (this.type === 'IMPORT_STATUS') {
      this.sampleLink = 'https://drive.google.com/uc?export=download&id=139ibxihoweb7Ludnj_5ZqYau-qbd8EV1'
    } else if (this.type === 'IMPORT_FEE') {
      this.sampleLink = 'https://drive.google.com/uc?export=download&id=1moJ4XGrZW00EsSnydUfnrtEO5bF3kp6l'
    } else if (this.type === 'IMPORT_LOCK_INFO') {
      this.sampleLink = 'https://drive.google.com/uc?export=download&id=1925nvldRmdpYoC6yNnOthiUQbuYMszfN'
    }
  },
  methods: {
    handleImportPhoneNumber () {
      if (this.phoneNumberFile) {
        if (this.phoneNumberFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          Utils.warnToast(this.$bvToast, 'Định dạng file không đúng', 'Vui lòng tải lên file có định dạng xslt')
        } else {
          const formData = new FormData()
          formData.append('company_id', this.company.id)
          formData.append('file', this.phoneNumberFile)
          formData.append('type', this.type)
          this.loading = true
          PhoneNumberApi.importPhoneNumber(formData).then(res => {
            this.loading = false
            this.items = res.data.data.rows
            this.record_id = res.data.data.id
          }).catch(err => {
            this.loading = false
            Utils.handleError(this.$bvToast, err)
          })
        }
      } else {
        Utils.warnToast(this.$bvToast, 'Chưa chọn file', 'Vui lòng tải lên file')
      }
    },
    confirmImportPhoneNumber () {
      if (this.record_id) {
        if (this.items.length !== 0) {
          this.$bvModal.msgBoxConfirm('File excel import vẫn còn lỗi, bạn có chắc chắn bỏ qua các lỗi và xác nhận import không?', {
            title: false,
            buttonSize: 'sm',
            centered: true,
            size: 'sm',
            footerClass: 'p-2'
          }).then(res => {
            if (res) {
              this.loading = true
              PhoneNumberApi.confirmImportPhoneNumber({company_id: this.company.id, id: this.record_id, type: this.type}).then(res => {
                this.loading = false
                Utils.successToast(this.$bvToast, 'Import số điện thoại', 'Đã xác nhận import số điện thoại thành công')
                this.record_id = null
                this.items = []
              }).catch(err => {
                this.loading = false
                Utils.handleError(this.$bvToast, err)
              })
            }
          })
        } else {
          this.loading = true
          PhoneNumberApi.confirmImportPhoneNumber({company_id: this.company.id, id: this.record_id, type: this.type}).then(res => {
            this.loading = false
            Utils.successToast(this.$bvToast, 'Import số điện thoại', 'Đã xác nhận import số điện thoại thành công')
            this.record_id = null
            this.items = []
          }).catch(err => {
            this.loading = false
            Utils.handleError(this.$bvToast, err)
          })
        }
      }
    },
    generateErrorFromErrorCode (error_code) {
      return IMPORT_ERROR_CODE[error_code.toString()]
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/phone_number_management/import_phone_number/ImportPhoneNumberSection.vue